export const getApiHostname = () => process.env.VUE_APP_API_BASE_URL || ''
